import { Modal, Row, Col, Form, message, Typography } from 'antd';
import CloseNoteTaskForm from '../CloseNoteTaskForm/CloseNoteTaskForm';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { closeTask, setShowNotaDeCierreModal, selectShowNotaDeCierreModal } from '../../../store/slice/taskSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as CloseTaskCheck } from '../../../res/svg/close-task-check.svg';
import './CloseNoteTaskModal.less';
/**
 * @component CloseNoteTaskModal.tsx
 * @description CloseNoteTaskModal component create note close when finalize the task.
 * @return { Component }
 */
function CloseNoteTaskModal() {
  const [form] = Form.useForm();
  const { Text } = Typography;
  const dispatch = useAppDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const showNotaDeCiereModal = useAppSelector(selectShowNotaDeCierreModal);

  //Se extrae el id de la URL
  const taskId = parseInt(location.pathname.split('/')[3]);


  const createNotaDeCierre = (taskId:number, notaDeCiereItem: string) => {
    dispatch(closeTask({taskId: taskId, notaDeCierre: notaDeCiereItem})).then((value: any) => {
      if(value.payload.status){
        navigate('/tareas');
      }
      else{
        message.error(value.payload.data?.message);
      }
    });
  };
  
  const handleOk = () => {
    form
      .validateFields()
      .then((values: any) => {
        createNotaDeCierre(taskId, values.notaDeCierre || null);
        dispatch(setShowNotaDeCierreModal(false));
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    dispatch(setShowNotaDeCierreModal(false));
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
  }, []);

  const TitleCustom = () =>{
    return(
        <div className={'title-custom'}>
           <CloseTaskCheck />
           <Text strong>Cerrar tarea</Text> 
        </div>
    )
  }

  return (
    <div>
      <Row>
        <Col span={24}>
          <Modal
            title={<TitleCustom />}
            visible={showNotaDeCiereModal as boolean}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={'Cerrar tarea'}
            width={556}
            centered={true}
            className={'org-task__modal'}
            cancelText='Cancelar'
            maskClosable={false}
          >
            <CloseNoteTaskForm
              form={form}
            />
          </Modal>
        </Col>
      </Row>
    </div>
  );
}

export default CloseNoteTaskModal;
